<template>
  <div class="container">
    <el-row :gutter="10">
       <el-col :span="4">
         <el-input v-model="searchText" placeholder="筛选"></el-input>
       </el-col>
       <el-col :span="6">
         <el-button type="primary" @click="refresh">刷新</el-button>
         &nbsp;&nbsp;&nbsp;&nbsp;
         <el-badge class="mark" :value="listByFilter.length">
           <el-tag type="success">总计</el-tag>
         </el-badge>
         &nbsp;&nbsp;&nbsp;&nbsp;
         <el-badge class="mark" :value="selectedRows.length">
           <el-tag type="primary">已选</el-tag>
         </el-badge>
       </el-col>
    </el-row>
    <el-table
      :data="listByFilter"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="eatery_name"
        label="食堂"
        width="180">
      </el-table-column>
      <el-table-column
        prop="canteen_name"
        label="餐厅"
        width="180">
      </el-table-column>
      <el-table-column
        label="日期"
        width="180">
        <template slot-scope="scope">
          {{tsToDate(scope.row.day_ts)}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goCheck(scope.row)" >纠错</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import pinyinMatch from 'pinyin-match';
import moment from 'moment';

export default {
  name: '',
  components: {},
  data () {
    return {
      searchText: '',
      selectedRows: []
    };
  },
  mounted () {
    this.setSubTitle('采集图片待纠错列表');
    this.refresh();
  },
  methods: {
    ...mapMutations([
      'setSubTitle',
      'emitLoading'
    ]),
    ...mapActions([
      'getDetectedUnCheckRemindList'
    ]),
    handleSelectionChange (row) {
      this.selectedRows = row;
    },
    tsToDate (ts) {
      return moment(ts * 1000).format('YYYY-MM-DD');
    },
    goCheck (row) {
      let {canteen_id, canteen_name} = row;
      this.$router.push({
        name: 'detectedImageCheck',
        query: {
          canteen: {
            canteen_id,
            canteen_name
          }
        }
      });
    },
    refresh () {
      this.getDetectedUnCheckRemindList({loadingShow: true});
    }
  },
  computed: {
    ...mapGetters([
      'detectedUnCheckList'
    ]),
    listByFilter () {
      let searchText = this.searchText;
      return this.detectedUnCheckList.filter((a) => {
        let res = pinyinMatch.match(a.canteen_name + ',' + a.eatery_name, searchText);
        return res.length > 0;
      });
    },
    userinfo () {
      return this.$store.getters.userinfo();
    },
    apiKey () {
      return this.userinfo.apiKey;
    }
  }
};
</script>
<style>

</style>
